import React from "react";
import {
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  ListItemSecondaryAction,
  Typography,
} from "@mui/material";
import { useApp } from "context";
import { Helpers } from "utils";
import { IProvider } from "interfaces";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";

type Props = {
  index?: number;
  provider: IProvider;
  onRemove?: (index: number) => void;
};

export const Provider = (props: Props) => {
  const { locale, t, theme, service } = useApp();
  const [favourite, setFavourite] = React.useState(false);

  React.useEffect(
    () => setFavourite(props.provider.favourite),
    [props.provider]
  );

  function handleFavourite() {
    setFavourite(!favourite);
    service.provider.favourite(props.provider.providerId, !favourite);
    if (favourite) {
      props.onRemove && props.onRemove(props.index ?? -1);
    }
  }

  return (
    <>
      <ListItem disableGutters disablePadding dense>
        <ListItemText
          primary={
            <Typography
              sx={{
                fontSize: theme.font.md,
                color: theme.palette.font.color,
              }}
            >
              {Helpers.replaceComma(props.provider.username)}
            </Typography>
          }
          secondary={
            <Typography
              sx={{
                fontSize: theme.font.sm,
                color: theme.palette.font.accent,
              }}
            >
              {props.provider.lastAppointment &&
              props.provider.lastAppointment.scheduledTime
                ? Helpers.interpolate(
                    t.message.appointment.related_appointment,
                    {
                      date: Helpers.toRelativeDate(
                        props.provider.lastAppointment.scheduledTime,
                        t.relative_date,
                        locale,
                        true
                      ),
                    }
                  )
                : t.message.appointment.not_visited}
            </Typography>
          }
        />
        <ListItemSecondaryAction>
          <IconButton
            sx={{ color: theme.palette.font.color }}
            onClick={handleFavourite}
          >
            {favourite ? <BookmarkIcon /> : <BookmarkBorderIcon />}
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
    </>
  );
};
